class SystemLevelLogsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID');
        this.organizationID = organizationID;
        this.subtableTemplate = null;
        this.subtableHeaderTemplate = null;
        this.datatable = this.init('#system-level-logs-datatable', organizationID);
        this.filterActions();
    }
    init(el, organizationID){
        const thisClass = this;
        // Get subtable template
        let subtable = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_template"]');
        let subtableHeader = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_header_template"]');
        this.subtableTemplate = subtable.cloneNode(true);
        this.subtableHeaderTemplate = subtableHeader.cloneNode(true);
        this.subtableTemplate.classList.remove('d-none');
        this.subtableHeaderTemplate.classList.remove('d-none');

        // Remove subtable template
        subtable.parentNode.removeChild(subtable);

        //
        // Pipelining function for DataTables. To be used to the `ajax` option of DataTables
        //
        $.fn.dataTable.pipeline = function (opts) {
            // Configuration options
            var conf = $.extend(
                {
                    pages: 5, // number of pages to cache
                    url: '', // script url
                    data: null, // function or object with parameters to send to the server
                    // matching how `ajax.data` works in DataTables
                    method: 'GET', // Ajax HTTP method
                },
                opts
            );

            // Private variables for storing the cache
            var cacheLower = -1;
            var cacheUpper = null;
            var cacheLastRequest = null;
            var cacheLastJson = null;

            return function (request, drawCallback, settings) {
                var ajax = false;
                var requestStart = request.start;
                var drawStart = request.start;
                var requestLength = request.length;
                var requestEnd = requestStart + requestLength;

                if (settings.clearCache) {
                    // API requested that the cache be cleared
                    ajax = true;
                    settings.clearCache = false;
                } else if (cacheLower < 0 || requestStart < cacheLower || requestEnd > cacheUpper) {
                    // outside cached data - need to make a request
                    ajax = true;
                } else if (
                    JSON.stringify(request.order) !== JSON.stringify(cacheLastRequest.order) ||
                    JSON.stringify(request.columns) !== JSON.stringify(cacheLastRequest.columns) ||
                    JSON.stringify(request.search) !== JSON.stringify(cacheLastRequest.search)
                ) {
                    // properties changed (ordering, columns, searching)
                    ajax = true;
                }

                // Store the request for checking next time around
                cacheLastRequest = $.extend(true, {}, request);

                if (ajax) {
                    // Need data from the server
                    if (requestStart < cacheLower) {
                        requestStart = requestStart - requestLength * (conf.pages - 1);

                        if (requestStart < 0) {
                            requestStart = 0;
                        }
                    }

                    cacheLower = requestStart;
                    cacheUpper = requestStart + requestLength * conf.pages;

                    request.start = requestStart;
                    request.length = requestLength * conf.pages;

                    // Provide the same `data` options as DataTables.
                    if (typeof conf.data === 'function') {
                        // As a function it is executed with the data object as an arg
                        // for manipulation. If an object is returned, it is used as the
                        // data object to submit
                        var d = conf.data(request);
                        if (d) {
                            $.extend(request, d);
                        }
                    } else if ($.isPlainObject(conf.data)) {
                        // As an object, the data given extends the default
                        $.extend(request, conf.data);
                    }

                    return $.ajax({
                        type: conf.method,
                        url: conf.url,
                        data: request,
                        dataType: 'json',
                        cache: false,
                        success: function (json) {
                            cacheLastJson = $.extend(true, {}, json);

                            if (cacheLower != drawStart) {
                                json.data.splice(0, drawStart - cacheLower);
                            }
                            if (requestLength >= -1) {
                                json.data.splice(requestLength, json.data.length);
                            }

                            drawCallback(json);
                        },
                    });
                } else {
                    let json = $.extend(true, {}, cacheLastJson);
                    json.draw = request.draw; // Update the echo for each response
                    json.data.splice(0, requestStart - cacheLower);
                    json.data.splice(requestLength, json.data.length);

                    drawCallback(json);
                }
            };
        };

        // Register an API method that will empty the pipelined data, forcing an Ajax
        // fetch on the next draw (i.e. `table.clearPipeline().draw()`)
        $.fn.dataTable.Api.register('clearPipeline()', function () {
            return this.iterator('table', function (settings) {
                settings.clearCache = true;
            });
        });

        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[3, 'asc']],
            searchCols: [
                null,
                null,
                null,
                { "search": (moment().startOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")+' - '+moment().endOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")), "regex": false }
            ],
            ajax: $.fn.dataTable.pipeline({
                url: '?do=getSystemLevelAccessLogs',
                type: 'POST',
                pages: 500, // number of pages to cache
                data: {
                    organizationID: organizationID,
                }
            }),
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=system-level-logs-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    sortable: false,
                    data: 'gatewayUuid',
                    render: function (data, type, row) {
                        return '<button type="button" class="btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-20px w-20px ' +
                            (!row['expand'] ? 'd-none' : '')+'" data-kt-docs-datatable-subtable="expand_row">\n' +
                            '<i class="ki-duotone ki-plus fs-3 m-0 toggle-off"></i><i class="ki-duotone ki-minus fs-3 m-0 toggle-on"></i></button>';
                    }
                },
                {
                    data: 'uuid',
                    title: 'Member',
                    className: 'min-w-100px',
                    sortable: false,
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row['vpnUserInfo']).generateTableMember();
                    }
                },
                {
                    data: 'systemUuid',
                    title: 'System',
                    className: 'min-w-100px',
                    sortable: false,
                    render: function (data, type, row) {
                        let iconUrl = '/media/goodaccess/icons/system/'+row['systemInfo']['iconID']+'.svg';
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden'+(!row['systemInfo']['isValid'] || row['systemInfo']['isIsolated'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="'+iconUrl+'" alt="icon">' +
                            '           </div>' +
                            (row['systemInfo']['isAdvanced'] ? '<span class="symbol-badge badge badge-circle bg-primary start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="'+row['systemInfo']['numberOfServices']+' services">'+row['systemInfo']['numberOfServices']+'</span>' : '')+
                            (!row['systemInfo']['isValid'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-9 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Invalid</div>">&#33;</span>' : '') +
                            (row['systemInfo']['isIsolated'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>Isolated</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div '+ (row['systemInfo']['edit'] ? 'id="'+row['systemInfo']['uuid']+'"' : '') +'><span class="fw-bold text-primary mb-1 fs-6' + (row['systemInfo']['edit'] ? ' text-decoration-underline-ga primary edit-system' : '') + '">'+row['systemInfo']['name']+'</span>'+
                            (row['systemInfo']['isIcmpProtocolEnabled'] ? '<span class="ms-2 fst-italic fs-9 badge badge-sm badge-warning py-1" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>ICMP protocol enabled</div>">ICMP</span>' : '')+
                            (row['systemInfo']['customUri'] ? '' : '<i class="fa-solid fa-eye-slash ga-text-primary-700 ms-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>Not visible as a System Shortcut in GoodAccess Client Application.</div>"></i>')+'</div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">'+(row['systemInfo']['customUri'] ?? row['systemInfo']['host'])+'</span>' +
                            '       </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'start',
                    title: 'Start',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['start']}</span>`;
                    }
                },
                {
                    data: 'stop',
                    title: 'Stop',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['stop']}</span>`;
                    }
                },
                {
                    data: 'duration',
                    title: 'Duration',
                    sortable: true,
                    render: function (data, type, row) {
                        return row['duration'];
                    }
                },
                {
                    data: 'download',
                    title: 'Data',
                    sortable: true,
                    className: 'min-w-80px',
                    render: function (data, type, row) {
                        return '<div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-up"></i>' +
                            '       <span>'+row['upload']+'</span>' +
                            '   </div>' +
                            '   <div class="text-nowrap">' +
                            '       <i class="fa-solid fa-arrow-down"></i>' +
                            '       <span>'+row['download']+'</span>' +
                            '   </div>';
                    }
                },
            ]
        }).on('preDraw', function () {
            $('#system-level-logs-datatable_wrapper').show();
            $('#system-level-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
        }).on('draw', function () {
            thisClass.resetSubtable(el);
            thisClass.handleActionButton(el);
            if(datatable.page.info().recordsTotal === 0){
                $('#system-level-logs-datatable_wrapper').hide();
                $('#system-level-logs-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#system-level-logs-datatable_wrapper').show();
                $('#system-level-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=search]');
        return datatable;
    }
    handleActionButton(el){
        const buttons = document.querySelectorAll('[data-kt-docs-datatable-subtable="expand_row"]');

        buttons.forEach((button, index) => {
            button.addEventListener('click', e => {
                e.stopImmediatePropagation();
                e.preventDefault();

                const row = button.closest('tr');
                const rowClasses = ['isOpen', 'border-bottom-0'];

                // Get total number of items to generate --- for demo purpose only, remove this code snippet in your project
                const demoData = [];
                let data = this.datatable.row(row).data().data;
                for (let j = 0; j < data.length; j++) {
                    demoData.push(data[j]);
                }
                // End of generating demo data

                // Handle subtable expanded state
                if (row.classList.contains('isOpen')) {
                    // Remove all subtables from current order row
                    while (row.nextSibling && (row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_template' || row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_header_template')) {
                        row.nextSibling.parentNode.removeChild(row.nextSibling);
                    }
                    row.classList.remove(...rowClasses);
                    button.classList.remove('active');
                } else {
                    this.populateTemplate(demoData, row, el);
                    row.classList.add(...rowClasses);
                    button.classList.add('active');
                }

                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
            });
        });
    }
    // Populate template with content/data -- content/data can be replaced with relevant data from database or API
    populateTemplate(data, target, el){
        let thisClass = this;
        data.forEach((d, index) => {
            // Clone template node
            const newTemplate = this.subtableTemplate.cloneNode(true);
            newTemplate.classList.remove('d-none');

            // Select data elements
            const gwImage = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_gw_image"]');
            const gwDown = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_gw_down"]');
            const gwName = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_gw_name"]');
            const gwIP = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_gw_ip"]');
            const start = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_start"]');
            const end = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_end"]');
            const duration = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_duration"]');
            const upload = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_upload"]');
            const download = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_download"]');
            const systemProtocol = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_system_protocol"]');
            const systemPort = newTemplate.querySelector('[data-kt-docs-datatable-subtable="template_system_port"]');

            // Populate elements with data
            if(d.gatewayInfo.status === 'down'){
                gwDown.classList.remove('d-none');
            } else {
                gwDown.remove();
            }
            gwImage.setAttribute('src', '/media/goodaccess/country-flags/png100px/'+d.gatewayInfo.iso2+'.png');
            gwName.innerText = d.gatewayInfo.name;
            gwIP.innerText = d.gatewayInfo.ip;
            start.setAttribute('data-bs-content', d.timezone);
            end.setAttribute('data-bs-content', d.timezone);
            start.innerHTML = d.start;
            end.innerHTML = d.end;
            duration.innerText = d.duration;
            upload.innerText = d.upload;
            download.innerText = d.download;
            systemProtocol.innerText = d.protocol;
            systemPort.innerText = d.port;

            if(d.gatewayInfo.edit){
                gwName.parentElement.id = d.gatewayInfo.uuid;
                gwName.classList.add('text-decoration-underline-ga', 'primary', 'edit-gateway')
            }

            // New template border controller
            if (data.length === 1) {
                if (index === 0) { // last row
                    let borderClasses = ['rounded-start', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[0].classList.add(...borderClasses);
                    borderClasses = ['rounded-end', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[6].classList.add(...borderClasses);
                }
            }

            // Insert new template into table
            const tbody = document.querySelector(el).querySelector('tbody');
            tbody.insertBefore(newTemplate, target.nextSibling);
        });

        const newHeaderTemplate = this.subtableHeaderTemplate.cloneNode(true);
        newHeaderTemplate.classList.remove('d-none');
        // Insert new template into table
        const tbody = document.querySelector(el).querySelector('tbody');
        tbody.insertBefore(newHeaderTemplate, target.nextSibling);
    }
    // Reset subtable
    resetSubtable(el){
        const subtables = document.querySelectorAll('[data-kt-docs-datatable-subtable="subtable_template"]');
        subtables.forEach(st => {
            st.parentNode.removeChild(st);
        });

        const rows = document.querySelector(el).querySelectorAll('tbody tr');
        rows.forEach(r => {
            r.classList.remove('isOpen');
            if (r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]')) {
                r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]').classList.remove('active');
            }
        });
    }
    filterActions(){
        this.initSelect2();
        this.initDateTimePicker();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
    }
    initSelect2(){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') + '</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('[data-kt-docs-table-filter=members]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=systems]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=gateways]').select2({
            laceholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
    }
    initDateTimePicker(){
        const dateEl = $("[data-kt-docs-table-filter=date]");
        let start = moment().startOf('isoWeek');
        let end = moment().endOf('isoWeek');

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=members]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=systems]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=gateways]').val([]).trigger('change');
                // Reset Date filter
                const dateEl = $("[data-kt-docs-table-filter=date]");
                dateEl.data('daterangepicker').setStartDate(moment().startOf('isoWeek'));
                dateEl.data('daterangepicker').setEndDate(moment().endOf('isoWeek'));

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 1; // Date is always set

        if(reset){
            this.datatable.columns().search('');
        } else {
            // Select filter options
            let date = document.querySelector('[data-kt-docs-table-filter="date"]');

            let members = $('[data-kt-docs-table-filter="members"]').select2('data');
            let membersArr = [];
            for(const i in members){
                if(members[i].id !== ''){
                    membersArr.push(members[i].id);
                }
            }

            let systems = $('[data-kt-docs-table-filter="systems"]').select2('data');
            let systemsArr = [];
            for(const i in systems){
                if(systems[i].id !== '') {
                    systemsArr.push(systems[i].id);
                }
            }

            let gateways = $('[data-kt-docs-table-filter="gateways"]').select2('data');
            let gatewaysArr = [];
            for(const i in gateways){
                if(gateways[i].id !== '') {
                    gatewaysArr.push(gateways[i].id);
                }
            }


            this.datatable.column(0).search(JSON.stringify(gatewaysArr));
            numberOfActiveFilters += gatewaysArr.length;
            this.datatable.column(1).search(JSON.stringify(membersArr));
            numberOfActiveFilters += membersArr.length;
            this.datatable.column(2).search(JSON.stringify(systemsArr));
            numberOfActiveFilters += systemsArr.length;
            this.datatable.column(3).search(date.value);
        }

        this.datatable.draw();

        $('#systemLevelLogsNumberOfFilters').text(numberOfActiveFilters);
    }
}
window.SystemLevelLogsDatatable = SystemLevelLogsDatatable;